import React from "react";
import styled from "styled-components";
import { getConfig } from "../../../../../../utils/config";
import { Link } from "react-router-dom";

import paths from "../../../menu";
import Text from "../../../../../../_components/Text";
import { useMenuNavigation } from "../../../hooks";
import AppContext from "../../../../context";
import { getCookieByName } from "../../../../../../utils";

const config = getConfig();

const excludePaths = config.menu.excludePaths;
const colors = config.theme.colors;
const navbar = config.theme.navbar;

const _paths = paths
  .map((path) => {
    if (excludePaths.includes(path.path)) {
      return null;
    }
    if (path.tree) {
      path.tree = path.tree.filter(
        (subPath) => !excludePaths.includes(subPath.path)
      );
    }
    return path;
  })
  .filter(Boolean);

const MenuItem = styled.li`
  a {
    margin-top: 4px;
    border-radius: 6px;
    display: flex;
    justify-content: space-between;
    align-items: start;
    gap: 10px;
    padding: 10px 20px;
    color: ${colors.white};
    text-decoration: none;
    font-size: 14px;

    &:hover {
      background-color: ${navbar.hover.backgroundColor} !important;
      * {
        color: ${navbar.hover.textColor} !important;
      }
    }

    &.active {
      background-color: ${navbar.active.backgroundColor};
      * {
        color: ${navbar.hover.textColor} !important;
      }
    }

    .badge {
      margin-left: auto;
      padding: 2px 6px;
      background-color: ${colors.success};
      border-radius: 10px;
      font-size: 12px;
      display: flex;
      align-items: center;
      gap: 5px;
    }
  }
`;
const MenuItemMain = styled.div`
  display: flex;
  align-items: center;

  i {
    color: ${colors.white};
    margin-right: 10px;
  }
`;
const MenuItemArrow = styled.div`
  i {
    color: ${colors.white};
    margin-right: 10px;
  }
`;
const SubMenu = styled.ul`
  width: 100%;
  list-style: none;
  padding-left: 0;
  background-color: ${navbar.submenu.backgroundColor};
  overflow: hidden;
  max-height: ${({ open }) => (open ? "500px" : "0px")};
  opacity: ${({ open }) => (open ? 1 : 0)};
  visibility: ${({ open }) => (open ? "visible" : "hidden")};
  transition: max-height 0.4s ease-in-out, opacity 0.4s ease-in-out,
    visibility 0.4s ease-in-out;

  li {
    width: 100%;
  }

  li > a {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 20px;
    color: ${colors.white};
    text-decoration: none;
    font-size: 14px;
    border-radius: 6px;
    transition: background-color 0.2s ease;

    &:hover {
      background-color: ${navbar.hover.backgroundColor} !important;
      * {
        color: ${navbar.hover.textColor} !important;
      }
    }

    &.active {
      background-color: ${navbar.active.backgroundColor};
      * {
        color: ${navbar.hover.textColor} !important;
      }
    }
  }
`;

export default function _SideMenus(props) {
  const ref = React.useRef(null);
  const [menus, setMenu] = React.useState([]);
  const context = React.useContext(AppContext);
  const [data, setData] = React.useState({ branchCount: 0 });
  const [openedMenus, setOpenedMenus] = React.useState([]);

  const [manageNavigation] = useMenuNavigation();

  const handleMenuClick = (menu) => {
    if (menu.tree && menu.tree.length) {
      setOpenedMenus(
        (prev) => (prev.includes(menu.label) ? [] : [menu.label]) // fecha todos os outros e mantém só um aberto
      );
    } else {
      manageNavigation(menu, context);
    }
  };
  const isMenuActive = (menu) => {
    if (!menu.tree || menu.tree.length === 0) {
      return location.pathname === menu.path;
    }
    return false;
  };
  const isSubItemActive = (menu) => {
    if (!menu.tree) return false;
    return menu.tree.some((sub) => location.pathname === sub.path);
  };

  React.useEffect(() => {
    const defaultOpened = menus
      .filter((menu) => isSubItemActive(menu))
      .map((m) => m.label);
    setOpenedMenus(defaultOpened);
    if (context.currentBranch && context.currentBranch.individual) {
      setMenu(_paths.filter((path) => path.fiscal === false));
    } else {
      setMenu(_paths);
    }

    setData({
      branchCount: getCookieByName("branch_count") || 1,
    });
  }, [location.pathname, menus]);

  return menus.map((menu, index) => {
    const isOpen = openedMenus.includes(menu.label);
    const isActive = isMenuActive(menu);

    return (
      <MenuItem ref={ref}>
        <Link
          onClick={(e) => {
            e.preventDefault();
            handleMenuClick(menu);
          }}
          id={menu.id}
          className={isActive ? "active" : ""}
        >
          <MenuItemMain>
            <i className={`fas fa-${menu.icon}`} />
            <span>
              <Text fontSize="14px" color="white">
                {menu.label}{" "}
                {menu.label === "Filiais" && data.branchCount ? (
                  `(${data.branchCount})`
                ) : (
                  <span />
                )}
              </Text>
            </span>
          </MenuItemMain>
          <div>
            {menu.badge && (
              <div className="badge">
                <Text color="white">{menu.badge}</Text>{" "}
                <Text color="warn">
                  <i className="fas fa-star" />
                </Text>
              </div>
            )}
          </div>
          <MenuItemArrow>
            {menu.tree && menu.tree.length > 0 && (
              <i
                style={{ fontSize: "12px" }}
                className={`fas fa-chevron-${isOpen ? "down" : "left"}`}
              />
            )}
          </MenuItemArrow>
        </Link>
        {isOpen && menu.tree && menu.tree.length > 0 && (
          <SubMenu open={isOpen}>
            {menu.tree.map((sub, i) => {
              if (config.views.excludevViews.includes(sub.path)) {
                return;
              }
              return (
                <li key={`sub-menu-${i}`}>
                  <Link
                    to={sub.path}
                    onClick={() => handleMenuClick(sub)}
                    id={menu.id}
                    className={location.pathname === sub.path ? "active" : ""}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginLeft: "20px",
                      }}
                    >
                      <i className={`fas mr-2 fa-${sub.icon}`} />
                      <Text fontSize="13px" color="white">
                        {sub.label}
                      </Text>
                    </div>
                  </Link>
                </li>
              );
            })}
          </SubMenu>
        )}
      </MenuItem>
    );
  });
}



// WEBPACK FOOTER //
// ./src/views/AppViews/Sidebar/components/SideArea/SideMenu/index.jsx